import login_image from "../image/bg1.png";
import med_logo from "../image/MEDDAILY-LOGO-inverted.png";
// import med_logo from "../image/logo.png";
import "../css/login.css";
import "../css/signup.css";
import { Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import play_app_icon from "../image/catalog/app.png";
import { useState } from "react";
import axios from "axios";

const Signup = () => {
  const [data, setData] = useState({
    businesstype: "",
    businessname: "",
    ownername: "",
    address: "",
    pincode: "",
    city: "",
    area: "",
    state: "",
    phonenumber: "",
    password: "",
    pharname: "",
    pharphone: "",
    licenseno: "",
    gstno: "",
    panno: "",
  });

  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const navigate = useNavigate()
  const handleChenge = (e) => {
    const { id, value } = e.target;
    setData({
      ...data,
      [id]: value,
    });
  };

  const handleFileChange1 = (e) => {
    setImage1(e.target.files[0]);
  };

  const handleFileChange2 = (e) => {
    setImage2(e.target.files[0]);
  };

  const handleSignup = (e) => {
    e.preventDefault();
    let formdata = new FormData();

    formdata.append("image1", image1);
    formdata.append("image2", image2);
    formdata.append("businesstype", data.businesstype);
    formdata.append("businessname", data.businessname);
    formdata.append("ownername", data.ownername);
    formdata.append("address", data.address);
    formdata.append("pincode", data.pincode);
    formdata.append("city", data.city);
    formdata.append("state", data.state);
    formdata.append("phonenumber", data.phonenumber);
    formdata.append("password", data.password);
    formdata.append("pharname", data.pharname);
    formdata.append("pharphone", data.pharphone);
    formdata.append("licenseno", data.licenseno);
    formdata.append("gstno", data.gstno);
    formdata.append("panno", data.panno);

    axios
      .post("http://api.meddaily.in/retailer_register", formdata)
      .then((res) => {
        console.log(res.data);
      navigate("/retailer_login")
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {/* <Navbar /> */}
      <div className="signup-body">
        <div className="big-img-div">
          <img src={login_image} alt="login" className="img-login" />
        </div>
        <form className="form-div">
          <Link style={{ textDecoration: "none" }} to="/">
            <img src={med_logo} alt="company_logo" width="250" height="100" />
          </Link>
          <div className="form">
            <Typography variant="h4" mt={8}>
              {" "}
              <strong>Create Account</strong>
            </Typography>
            <Typography color="#2D3748" mb={4}>
              {" "}
              For Retailers.
            </Typography>

            <div className="div-4-data">
              <div>
                <Typography>
                  <strong>Type of Business</strong>
                </Typography>
                <input
                  placeholder="Type of Business"
                  className="form-data"
                  id="businesstype"
                  type="text"
                  onChange={handleChenge}
                  name="businesstype"
                  value={data.businesstype}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Type of Business</strong>
                </Typography>
                <input
                  placeholder="Type of Business"
                  className="form-data"
                  id="businessname"
                  type="text"
                  onChange={handleChenge}
                  name="businessname"
                  value={data.businessname}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Owner Name</strong>
                </Typography>
                <input
                  placeholder="Owner Name"
                  className="form-data"
                  id="ownername"
                  type="text"
                  onChange={handleChenge}
                  name="ownername"
                  value={data.ownername}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Business Address</strong>
                </Typography>
                <input
                  placeholder="Business Address"
                  className="form-data"
                  id="address"
                  type="text"
                  onChange={handleChenge}
                  name="address"
                  value={data.address}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Pincode</strong>
                </Typography>
                <input
                  placeholder="Pincode"
                  className="form-data"
                  id="pincode"
                  type="text"
                  onChange={handleChenge}
                  name="pincode"
                  value={data.pincode}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>City</strong>
                </Typography>
                <input
                  placeholder="City"
                  className="form-data"
                  id="city"
                  type="text"
                  onChange={handleChenge}
                  name="city"
                  value={data.city}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Area</strong>
                </Typography>
                <input
                  placeholder="Area"
                  className="form-data"
                  id="area"
                  type="text"
                  onChange={handleChenge}
                  name="area"
                  value={data.area}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Select State</strong>
                </Typography>
                <input
                  placeholder="Select State"
                  className="form-data"
                  id="state"
                  type="text"
                  onChange={handleChenge}
                  name="state"
                  value={data.state}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Phone Number</strong>
                </Typography>
                <input
                  placeholder="Phone Number"
                  className="form-data"
                  id="phonenumber"
                  type="text"
                  onChange={handleChenge}
                  name="phonenumber"
                  value={data.phonenumber}
                ></input>
              </div>
              {/* <div>
                <Typography>
                  <strong>Email</strong>
                </Typography>
                <input placeholder="Email" className="form-data"
                  id="email"
                  type="text"
                  onChange={handleChenge}
                  name="email"
                  value={data.email}
                ></input>
              </div> */}
              <div>
                <Typography>
                  <strong>Password</strong>
                </Typography>
                <input
                  placeholder="Password"
                  className="form-data"
                  id="password"
                  type="text"
                  onChange={handleChenge}
                  name="password"
                  value={data.password}
                ></input>
              </div>
              {/* <div>
                <Typography>
                  <strong>Confirm Password</strong>
                </Typography>
                <input
                  placeholder="Confirm Password"
                  className="form-data"
                  id="confirmPassWord"
                  type="text"
                  onChange={handleChenge}
                  name="confirmPassWord"
                  value={data.confirmPassWord}
                ></input>
              </div> */}
              <div>
                <Typography>
                  <strong>Pharmacist Name</strong>
                </Typography>
                <input
                  placeholder="Pharmacist Name"
                  className="form-data"
                  id="pharname"
                  type="text"
                  onChange={handleChenge}
                  name="pharname"
                  value={data.pharname}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Pharmacist Phone No. 1</strong>
                </Typography>
                <input
                  placeholder="Pharmacist Phone No. 1"
                  className="form-data"
                  id="pharphone"
                  type="text"
                  onChange={handleChenge}
                  name="pharphone"
                  value={data.pharphone}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Add Drug License number</strong>
                </Typography>
                <input
                  placeholder="Add Drug License number"
                  className="form-data"
                  id="licenseno"
                  type="text"
                  onChange={handleChenge}
                  name="licenseno"
                  value={data.licenseno}
                ></input>
              </div>
              <div>
                <Typography>
                  <strong>Upload Drug License</strong>
                </Typography>
                <input
                  type="file"
                  name="file"
                  className="form-data"
                  onChange={handleFileChange1}
                />
                {/* <input placeholder="Password" className="form-data"></input> */}
              </div>
              <div>
                <Typography>
                  <strong>GSTIN Number</strong>
                </Typography>
                <input
                  placeholder="GSTIN Number"
                  className="form-data"
                  id="gstno"
                  type="text"
                  onChange={handleChenge}
                  name="gstno"
                  value={data.gstno}
                ></input>
              </div>

              <div>
                <Typography>
                  <strong>GSTIN Certification</strong>
                </Typography>
                <input
                  type="file"
                  className="form-data"
                  onChange={handleFileChange2}
                />
              </div>
              <div>
                <Typography>
                  <strong>Pan Number</strong>
                </Typography>
                <input
                  placeholder="Pan Number"
                  className="form-data"
                  id="panno"
                  type="text"
                  onChange={handleChenge}
                  name="panno"
                  value={data.panno}
                ></input>
              </div>
            </div>

            <div className="create-acc-div">
              <button className="register-button" onClick={handleSignup}>
                Create Account
              </button>

              <Typography mt={2} mb={6}>
                {" "}
                Already have an account?{" "}
                <Link to="/retailer_login">Log In</Link>
              </Typography>
              <img src={play_app_icon} alt="logo" className="play_app_icon" />
            </div>
          </div>
        </form>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Signup;
